import type { IconData } from '@stacksjs/iconify-core'

export const switchLeftF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 0h8a6 6 0 1 1 0 12H6A6 6 0 1 1 6 0m1 10a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default switchLeftF
